import { HList } from '@sleepstation/components-layouts'
import { LAYOUT_CHILD, LAYOUT_SPACING } from '@sleepstation/const'
import { renderList } from '@sleepstation/utils'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import CardLink from './CardLink'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(HList).attrs({
  spacing: LAYOUT_SPACING.LARGE,
  child: LAYOUT_CHILD.EQUAL,
})``

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const CardLinkList = ({ links }) => (
  <Layout>
    {renderList(
      (props) => (
        <CardLink {...props} />
      ),
      links
    )}
  </Layout>
)

CardLinkList.propTypes = {
  links: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default CardLinkList
